import { useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi } from '../../api/configuration';

export function ImportExportWizardPage() {
  const [exportData, setExportData] = useState('');
  const [importData, setImportData] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  async function handleExport() {
    try {
      const data = await configurationApi.exportConfig();
      setExportData(JSON.stringify(data, null, 2));
      setStatus('Export complete.');
    } catch (e) {
      setError(String(e));
    }
  }

  async function handleImport() {
    try {
      const payload = JSON.parse(importData) as unknown;
      await configurationApi.importConfig(payload);
      setStatus('Import complete.');
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Import / Export Wizard</h1>
      <div className="mt-6 grid gap-6 md:grid-cols-2">
        <div>
          <h2 className="font-medium">Export</h2>
          <button type="button" onClick={() => void handleExport()} className="mt-2 rounded bg-blue-600 px-4 py-2 text-sm text-white">Export configuration</button>
          <textarea readOnly value={exportData} rows={12} className="mt-3 w-full rounded border font-mono text-xs dark:border-slate-600 dark:bg-slate-900" />
        </div>
        <div>
          <h2 className="font-medium">Import</h2>
          <textarea value={importData} onChange={(e) => setImportData(e.target.value)} rows={12} placeholder="Paste JSON export..." className="mt-2 w-full rounded border font-mono text-xs dark:border-slate-600 dark:bg-slate-900" />
          <button type="button" onClick={() => void handleImport()} className="mt-2 rounded bg-green-600 px-4 py-2 text-sm text-white">Import configuration</button>
        </div>
      </div>
      {status && <p className="mt-4 text-sm text-green-600">{status}</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
    </div>
  );
}
